'use client'

import { PropsWithChildren } from 'react'

import { ErrorBoundary } from '@marketplace-web/error-display/error-display-util'
import { useSession } from '@marketplace-web/shared/session-data'

import { incrementPageLoadFailureCounter, logHomeError } from '../utils/client-observability'
import ErrorState from '../common/ErrorState'

const HomeErrorBoundary = (props: PropsWithChildren<unknown>) => {
  const userId = useSession().user?.id

  const trackBoundaryError = (boundaryError: Error | null) => {
    incrementPageLoadFailureCounter({ homepage_reason: 'boundary' })
    logHomeError(boundaryError, undefined, `user_id=${userId || 'not_logged_in'}`)
  }

  return (
    <ErrorBoundary onError={trackBoundaryError} FallbackComponent={ErrorState}>
      {props.children}
    </ErrorBoundary>
  )
}

export default HomeErrorBoundary
